const InstagramSection = () => {
  const instagramPosts = [
    {
      id: 1,
      image: 'https://drive.google.com/thumbnail?id=1sY8E2RsF9V4SQb5q2SpSGTuXFsMyYIUQ&sz=w600',
      link: 'https://www.instagram.com/p/DJg36Zpoh49/'
    },
    {
      id: 2,
      image: 'https://drive.google.com/thumbnail?id=1h_xqvD6LpZ6229fnezn2iJXw1rzP8zxQ&sz=w600',
      link: 'https://www.instagram.com/p/DKhT7AoPiWY/'
    },
    {
      id: 3,
      image: 'https://drive.google.com/thumbnail?id=1Si5ZRWrLcgPrkKCjgRf62x0IJor8N5FN&sz=w600',
      link: 'https://www.instagram.com/p/DL_ESyhuhuc/'
    },
    {
      id: 4,
      image: 'https://drive.google.com/thumbnail?id=1CXsvlRV-EFYeAU8pzchhlXIsS7KlnX8E&sz=w600',
      link: 'https://www.instagram.com/p/DReu3valEur/'
    },
    {
      id: 5,
      image: 'https://drive.google.com/thumbnail?id=1R40aJKb3ewc9iauAKiKyynyYHC6DpqM4&sz=w600',
      link: 'https://www.instagram.com/p/DMvlksKOZVQ/'
    },
    {
      id: 6,
      image: 'https://drive.google.com/thumbnail?id=1traQdBlDnXmCAdqsAgtRSn5Sn6mZ3zPF&sz=w600',
      link: 'https://www.instagram.com/p/DG7sRNuunXC/'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 flex items-center justify-center">
            Nosso Instagram
            <i className="ri-instagram-fill text-pink-500 ml-4 text-5xl"></i>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Acompanhe nosso dia a dia, novidades, e muito mais em nosso Instagram oficial.
          </p>
        </div>

        {/* Instagram Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-12">
          {instagramPosts.map((post) => (
            <a
              key={post.id}
              href={post.link}
              target="_blank"
              rel="noopener noreferrer"
              className="group aspect-square overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-all duration-300"
            >
              <div className="relative w-full h-full">
                <img 
                  src={post.image}
                  alt={`Instagram post ${post.id}`}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300 flex items-center justify-center">
                  <i className="ri-instagram-fill text-white text-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></i>
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* Follow Button */}
        <div className="text-center">
          <a
            href="https://www.instagram.com/sustentarealimentos/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-purple-500 to-pink-500 text-white font-semibold rounded-lg hover:from-purple-600 hover:to-pink-600 transition-all duration-300 transform hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-instagram-fill mr-3 text-xl"></i>
            Seguir no Instagram
          </a>
        </div>
      </div>
    </section>
  );
};

export default InstagramSection;